import { useEffect } from "react";
import { useLoading } from "@/context/LoadingContext";
import { useToast } from "@/hooks/useToast";
import { ErrorAlert } from "@/utils/alert";

interface UseQueryHandlerProps {
  isFetching?: boolean;
  isError?: boolean;
  error?: unknown;
  errorTitle?: string;
  errorMessage?: string;
  isSuccess?: boolean;
  successTitle?: string;
  successMessage?: string;
}

export const useQueryHandler = ({
  isFetching = false,
  isError = false,
  error,
  errorTitle = "Error",
  errorMessage = "เกิดข้อผิดพลาด",
  isSuccess = false,
  successMessage = "ดำเนินการสำเร็จ",
}: UseQueryHandlerProps) => {
  const { increaseLoading, decreaseLoading } = useLoading();
  const { showToast } = useToast();
  useEffect(() => {
    if (!isFetching) return;
    increaseLoading();
    return () => decreaseLoading();
  }, [isFetching, increaseLoading, decreaseLoading]);

  useEffect(() => {
    if (isError) {
      ErrorAlert(errorTitle, errorMessage);
      console.error("Query Error:", error);
    }
  }, [isError, errorTitle, errorMessage, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast(successMessage, "success");
    }
  }, [isSuccess, successMessage, showToast]);
};
